import config from "@Config/index";
import { getImageSrc } from "@Components/Image";

/**
 * Resolves an Essential Kit asset path against the configured asset base.
 *
 * Every asset/font reference in the feature must flow through this helper so the
 * base is swappable without touching components:
 *   - POC:        UNIKIT_ASSET_URL = "/static/essential-kit/" (served from public/)
 *   - Final step: UNIKIT_ASSET_URL = the gumlet CDN base (config-only change)
 *
 * On China builds the gumlet base is transparently rewritten to the China CDN
 * via `getImageSrc`.
 *
 * Only known local roots (`/assets/`, `/fonts/`) are rewritten. Absolute URLs and
 * any other path are returned unchanged. Replaces the source's Vite-only
 * `import.meta.env.BASE_URL` implementation.
 */
export const assetUrl = (path: string): string => {
  if (!path) return path;
  if (/^https?:\/\//.test(path)) return getImageSrc(path);
  if (!path.startsWith("/assets/") && !path.startsWith("/fonts/")) return path;

  const rawBase = config.UNIKIT_ASSET_URL || "/";
  const base = rawBase.endsWith("/") ? rawBase : `${rawBase}/`;
  return getImageSrc(`${base}${path.slice(1)}`);
};

export default assetUrl;
